import React, { useState } from 'react';
import { api } from '../api';
import { fmt } from '../utils';

export default function CostSection({ deal, table, title, benchmarkLabel, benchmarkValue, onUpdate }) {
  const [recalculating, setRecalculating] = useState(false);

  const handleRecalculate = async () => {
    setRecalculating(true);
    await api.recalculateCosts(deal.id);
    setRecalculating(false);
    onUpdate();
  };
  const items = deal[table] || [];
  const [adding, setAdding] = useState(false);
  const [newLabel, setNewLabel] = useState('');

  const totalBudgeted = items.reduce((s, r) => s + (r.budgeted || 0), 0);
  const totalActual   = items.reduce((s, r) => s + (r.actual  || 0), 0);

  const handleChange = async (item, field, value) => {
    await api.updateCostLine(deal.id, table, item.id, { [field]: value === '' ? 0 : parseFloat(value) || 0 });
    onUpdate();
  };

  const handleLabelChange = async (item, value) => {
    await api.updateCostLine(deal.id, table, item.id, { label: value });
    onUpdate();
  };

  const handleAdd = async () => {
    if (!newLabel.trim()) return;
    await api.addCostLine(deal.id, table, { label: newLabel.trim() });
    setNewLabel('');
    setAdding(false);
    onUpdate();
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`Remove "${item.label}"?`)) return;
    await api.deleteCostLine(deal.id, table, item.id);
    onUpdate();
  };

  const over = totalBudgeted > benchmarkValue * 1.05;

  return (
    <div className="card deal-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div className="section-title" style={{ marginBottom: 0 }}>{title}</div>
        {table === 'frontend_costs' && (
          <button
            className="btn-ghost"
            onClick={handleRecalculate}
            disabled={recalculating}
            title="Recalculate Title Costs and HM Origination from current purchase price"
            style={{ fontSize: 11, color: 'var(--brand)', padding: '3px 8px' }}
          >
            {recalculating ? 'Recalculating…' : '↺ Recalculate'}
          </button>
        )}
      </div>
      <table className="cost-table">
        <thead>
          <tr>
            <th style={{width:'40%'}}>Item</th>
            <th className="right">Budgeted</th>
            <th className="right">Actual</th>
            <th style={{width:32}}></th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id} className="cost-row">
              <td>
                <input
                  className="inline-edit"
                  defaultValue={item.label}
                  onBlur={e => e.target.value !== item.label && handleLabelChange(item, e.target.value)}
                  style={{width:'100%'}}
                />
              </td>
              <td className="right">
                <input
                  type="number" className="inline-edit" style={{width:90,textAlign:'right'}}
                  defaultValue={item.budgeted || ''}
                  placeholder="0"
                  onBlur={e => handleChange(item, 'budgeted', e.target.value)}
                />
              </td>
              <td className="right">
                <input
                  type="number" className="inline-edit" style={{width:90,textAlign:'right'}}
                  defaultValue={item.actual || ''}
                  placeholder="0"
                  onBlur={e => handleChange(item, 'actual', e.target.value)}
                />
              </td>
              <td>
                <button className="btn-ghost" style={{padding:'2px 6px',color:'#ccc'}} onClick={() => handleDelete(item)}>✕</button>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="total-row">
            <td>Total</td>
            <td className={`right money ${over ? 'over-budget' : ''}`}>{fmt(totalBudgeted)}</td>
            <td className="right money">{fmt(totalActual)}</td>
            <td></td>
          </tr>
          {benchmarkValue > 0 && (
            <tr className="benchmark-row">
              <td colSpan={4} style={{color: over ? 'var(--danger)' : 'var(--text-muted)'}}>
                {benchmarkLabel}: {fmt(benchmarkValue)} {over ? '⚠ Over benchmark' : '✓'}
              </td>
            </tr>
          )}
        </tfoot>
      </table>

      {adding ? (
        <div style={{display:'flex',gap:8,marginTop:10}}>
          <input value={newLabel} onChange={e => setNewLabel(e.target.value)}
            placeholder="Line item label" autoFocus
            onKeyDown={e => { if (e.key === 'Enter') handleAdd(); if (e.key === 'Escape') setAdding(false); }}
            style={{flex:1}} />
          <button className="btn-primary" onClick={handleAdd}>Add</button>
          <button className="btn-secondary" onClick={() => setAdding(false)}>Cancel</button>
        </div>
      ) : (
        <button className="add-line-btn" onClick={() => setAdding(true)}>+ Add line item</button>
      )}
    </div>
  );
}
